import { Stack, Typography } from '@mui/material';

interface DpBreadcrumbCardFrameProps {
	title?: string;
	children: React.ReactNode;
}

export const DpBreadcrumbCardFrame: React.FC<DpBreadcrumbCardFrameProps> = ({
	children,
	title,
}) => (
	<Stack
		sx={{
			marginBottom: '15px',
			mt: { xs: '0px', md: '15px' },
		}}
	>
		{title ? (
			<Typography
				sx={{
					fontSize: { xs: '14px', sm: '15px' },
					fontWeight: '800',
					marginBottom: '11px',
				}}
			>
				{title}
			</Typography>
		) : null}
		<Stack
			direction="row"
			sx={{
				gap: '7px',
				padding: '5px',
				overflow: 'auto',
			}}
		>
			{children}
		</Stack>
	</Stack>
);
